<script setup lang="ts">
import CountDown from "@chenfengyuan/vue-countdown";

type TimeUnits = "day" | "hour" | "minute" | "second";
interface CountdownText extends Record<string, Record<TimeUnits, string>> {}

defineEmits(["countdownEnded"]);
const props = defineProps({
  datetime: {
    type: String,
    required: true,
  },
  timeStyle: {
    default: "twoUnits",
    validator: (value: string) => {
      return ["twoUnits", "allUnits", "secondsOnly"].includes(value);
    },
  },
  textStyle: {
    default: "default",
    validator: (value: string) => {
      return ["default", "abbreviated"].includes(value);
    },
  },
});

const now = new Date().getTime();
const next = new Date(props.datetime).getTime();
const time = next - now;

const getText: CountdownText = {
  abbreviated: {
    day: "main.time.shortDay",
    hour: "main.time.shortHour",
    minute: "main.time.shortMinute",
    second: "main.time.shortSecond",
  },
  default: {
    day: "main.time.day",
    hour: "main.time.hour",
    minute: "main.time.minute",
    second: "main.time.second",
  },
};
</script>

<template>
  <div>
    <CountDown
      v-slot="{ days, hours, minutes, seconds }"
      :time="time"
      @end="$emit('countdownEnded')">
      <div v-if="timeStyle === 'twoUnits'" class="flex gap-1">
        <p
          v-if="days"
          v-t="{
            path: getText[textStyle].day,
            plural: days,
            args: { value: days },
          }"></p>
        <p
          v-if="hours && days"
          v-t="{
            path: getText[textStyle].hour,
            plural: hours,
            args: { value: hours },
          }"></p>
        <p
          v-if="hours && !days"
          v-t="{
            path: getText[textStyle].hour,
            plural: hours,
            args: { value: hours },
          }"></p>
        <p
          v-if="minutes && !days"
          v-t="{
            path: getText[textStyle].minute,
            plural: minutes,
            args: { value: minutes },
          }"></p>
        <p
          v-if="seconds && !days"
          v-t="{
            path: getText[textStyle].second,
            plural: seconds,
            args: { value: seconds },
          }"></p>
      </div>
      <div v-if="timeStyle === 'allUnits'" class="flex gap-1">
        <p
          v-if="days"
          v-t="{
            path: getText[textStyle].day,
            plural: days,
            args: { value: days },
          }"></p>
        <p
          v-if="hours && days"
          v-t="{
            path: getText[textStyle].hour,
            plural: hours,
            args: { value: hours },
          }"></p>
        <p
          v-if="hours && !days"
          v-t="{
            path: getText[textStyle].hour,
            plural: hours,
            args: { value: hours },
          }"></p>
        <p
          v-if="minutes && !days"
          v-t="{
            path: getText[textStyle].minute,
            plural: minutes,
            args: { value: minutes },
          }"></p>
        <p
          v-if="seconds && !days"
          v-t="{
            path: getText[textStyle].second,
            plural: seconds,
            args: { value: seconds },
          }"></p>
      </div>
      <div v-if="timeStyle === 'secondsOnly'" class="flex gap-1">
        <p
          v-if="seconds"
          v-t="{
            path: 'main.time.second',
            plural: seconds,
            args: { value: seconds },
          }"></p>
      </div>
    </CountDown>
  </div>
</template>
